import React from 'react';
import { Link } from 'react-router-dom';
import { LuBriefcase, LuBuilding2 } from 'react-icons/lu';
import { MdStorefront } from 'react-icons/md';
import { Avatar } from 'components/common';
import { PersonRenderer } from 'components/common/ag-grid';
import EmailRenderer from 'components/common/ag-grid/EmailRenderer';
import { iconCell } from 'components/common/ag-grid';
import PhoneRenderer from 'components/common/ag-grid/PhoneRenderer';
import ContactLink from './ContactLink';
import ContactSecondaryBadge from './ContactSecondaryBadge';


// Company mark + link to the customer detail (contact rows carry company.{id,name}).
const CompanyCell = (p) => {
  const company = p.data?.company;
  if (!company?.name) return null;
  const label = (
    <span className="tw-inline-flex tw-items-center tw-gap-2 tw-max-w-full">
      <Avatar src={company.logo_url || undefined} name={company.name} alt={company.name} size="xs" className="tw-shrink-0" />
      {company.id
        ? <Link to={`/crm/customers/${company.id}`} className="tw-truncate">{company.name}</Link>
        : <span className="tw-truncate">{company.name}</span>}
    </span>
  );
  return label;
};
import LeadLink from 'components/app/crm/lead/component/LeadLink';

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'contact_code',
    minWidth: 110
  },
  {
    headerName: 'Contact name',
    cellRendererParams: { withAvatar: true },
    field: 'name',
    minWidth: 200,
    pinned: 'left',
    cellRenderer: ContactLink
  },
  { 
    headerName: 'Salutation',
    field: 'salutation',
    minWidth: 150
  },
  { 
    headerName: 'First name',
    field: 'first_name',
    minWidth: 150
  },
  { 
    headerName: 'Last name',
    field: 'last_name',
    minWidth: 150
  },
  { 
    headerName: 'Email',
    field: 'email',
    minWidth: 200,
    cellRenderer: EmailRenderer
  },
  { 
    headerName: 'Mobile',
    field: 'mobile',
    minWidth: 200,
    cellRenderer: PhoneRenderer
  },
  { 
    headerName: 'Position',
    field: 'position',
    minWidth: 200,
    cellRenderer: iconCell(LuBriefcase)
  },
  { 
    headerName: 'Department',
    field: 'department',
    minWidth: 200,
    cellRenderer: iconCell(LuBuilding2)
  },
  { 
    headerName: 'Main contact',
    field: 'main_contact',
    cellRenderer: PersonRenderer,
    minWidth: 150
  },
  { 
    headerName: 'Secondary contact',
    field: 'secondary_contact',
    minWidth: 200,
    cellRenderer: ContactSecondaryBadge
  },
  { 
    headerName: 'Other contact',
    field: 'other_contact',
    minWidth: 150
  },
  { 
    headerName: 'Buying roles',
    field: 'buying_roles',
    minWidth: 150
  },
  { 
    headerName: 'Company',
    field: 'company.name',
    minWidth: 250,
    cellRenderer: CompanyCell
  },
  { 
    headerName: 'Lead',
    field: 'lead.name',
    minWidth: 150,
    cellRenderer: LeadLink
  },
  { 
    headerName: 'Sales unit',
    field: 'sales_unit.description',
    cellRenderer: iconCell(MdStorefront),
    minWidth: 150
  },
  { 
    headerName: 'Personal page',
    field: 'personal_page',
    minWidth: 150
  },
  { 
    headerName: 'Messenger',
    field: 'messenger',
    minWidth: 150,
  },
  { 
    headerName: 'Updated date',
    field: 'updated_at',
    minWidth: 200
  },
  { 
    headerName: 'Created by',
    field: 'created_by',
    cellRenderer: PersonRenderer,
    minWidth: 120
  },
  { 
    headerName: 'Created date',
    field: 'created_at',
    minWidth: 200
  }
];
